import { render } from "./MySelect.vue?vue&type=template&id=3e8c38c2&scoped=true"
import script from "./MySelect.vue?vue&type=script&lang=js"
export * from "./MySelect.vue?vue&type=script&lang=js"

import "./MySelect.vue?vue&type=style&index=0&id=3e8c38c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8c38c2"]])

export default __exports__